<!-- <p>gsm-and-weight works!</p> -->
<div class="gms_and_weight_cont" *ngIf="dataGsm.gsm  && dataGsm.width">
	<div class="weight" *ngIf="dataGsm.gsm">Weight: {{dataGsm.gsm}} GSM</div>
	<span  *ngIf="dataGsm.gsm">&nbsp;|&nbsp;</span>
	<div class="width">
		Width: {{dataGsm.width}}
	</div>
</div>
